export const environment = {
  production: false,
  name: 'hetzner-nginx-ssl',

  apiBaseUrl:  'https://api.myvocabulary.net/api/v1/vocabulary',
  keycloakUrl: 'https://auth.myvocabulary.net',

  keycloakUrlPattern: /^(https:\/\/api\.myvocabulary\.net)(\/.*)?$/i,

  googleAnalyticsId: 'G-085YRTFZLZ',
  turnstileSiteKey: '0x4AAAAAACkkhr5WRvYvnsva'
};
